export const TEXT_KEYS = {
    REDEEM_MAIN_PAGE_TITLE: 'platform-selection__title',
    REDEEM_MAIN_PAGE_TITLE_SINGLE_PLATFORM: 'platform-selection__title-single-platform',
    REDEEM_MAIN_PAGE_BUTTON: 'platform-selection__button',
    REDEEM_CODE_TITLE: 'redeem-code__title',
    REDEEM_CODE_MESSAGE: 'redeem-code__message'
};

export const CODE_URL_PARAMETER = 'code';
export const PLATFORM_URL_PARAMETER = 'platform';
